import { BroadcastForm } from '../broadcast-form';

export const BroadcastView = () => {
  return <BroadcastForm />;
};
